import { HttpClient } from '@opallabs/api'
import loadSlide from '../loadSlide'

const fetchSlide = (presentationId, slideId) =>
  HttpClient().get(
    `/api/v1/presentations/${presentationId}/canvas_slides/${slideId}`
  )

const getSlide = (presentationId, slideId) => (dispatch) =>
  fetchSlide(presentationId, slideId)
    .then((response) => dispatch(loadSlide(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getSlide
